import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-3 col-md-4" }
const _hoisted_13 = { class: "col-lg-9 col-md-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusContent = _resolveComponent("StatusContent")!
  const _component_PerformanceOverviewChart = _resolveComponent("PerformanceOverviewChart")!
  const _component_NewMobileApp = _resolveComponent("NewMobileApp")!
  const _component_HighlightsContent = _resolveComponent("HighlightsContent")!
  const _component_ChannelsContent = _resolveComponent("ChannelsContent")!
  const _component_CampaignsContent = _resolveComponent("CampaignsContent")!
  const _component_ExternalLinks = _resolveComponent("ExternalLinks")!
  const _component_InstagramCampaignsChart = _resolveComponent("InstagramCampaignsChart")!
  const _component_NewMarketingTool = _resolveComponent("NewMarketingTool")!
  const _component_InstagramSubscriberChart = _resolveComponent("InstagramSubscriberChart")!
  const _component_CreateCampaignsModal = _resolveComponent("CreateCampaignsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_StatusContent),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_PerformanceOverviewChart)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_NewMobileApp)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_HighlightsContent),
          _createVNode(_component_ChannelsContent)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_CampaignsContent),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ExternalLinks)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_InstagramCampaignsChart)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_NewMarketingTool)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_InstagramSubscriberChart)
        ])
      ])
    ]),
    _createVNode(_component_CreateCampaignsModal)
  ], 64))
}